import { memo, useEffect } from "react";
import { Box, Link, List, ListItem, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { FETCH_SERVICE_JOB } from "@services/graphql/queries/fetchServiceJob";
import { useDispatch } from "react-redux";
import { handleErrorWithNotification } from "@/utils/errorHandling";

const WesentlichkeitJobResultPage = memo(() => {
    const dispatch = useDispatch();
    const { id } = useParams<{ id: string }>();
    const { data, loading, error } = useQuery(FETCH_SERVICE_JOB, {
        variables: { id },
        skip: !id,
        errorPolicy: "all",
    });

    // Notify on error
    useEffect(() => {
        if (error) {
            handleErrorWithNotification(error as Error, dispatch, "Fehler", "Die Ergebnisse konnten nicht geladen werden");
        }
    }, [error, dispatch]);

    if (loading) {
        return <Typography sx={{ p: 3 }}>Lade Ergebnisse…</Typography>;
    }

    const job = data?.serviceJob;

    if (!job) {
        return <Typography sx={{ p: 3 }}>Kein Job gefunden.</Typography>;
    }

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Analyseergebnisse
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
                Status: {job.status}
            </Typography>

            {job.resultData && (
                <>
                    <Typography variant="h6">Strukturierte Daten</Typography>
                    <pre style={{ whiteSpace: "pre-wrap", background: "#f7f7f7", padding: "1rem", borderRadius: 4 }}>{JSON.stringify(job.resultData, null, 2)}</pre>
                </>
            )}

            {job.resultFiles && job.resultFiles.length > 0 && (
                <>
                    <Typography variant="h6" sx={{ mt: 2 }}>
                        Ergebnisdateien
                    </Typography>
                    <List>
                        {job.resultFiles.map((url: string, idx: number) => (
                            <ListItem key={idx} sx={{ display: "list-item", pl: 2 }}>
                                <Link href={url} target="_blank" rel="noopener noreferrer">
                                    {url}
                                </Link>
                            </ListItem>
                        ))}
                    </List>
                </>
            )}
        </Box>
    );
});

export default WesentlichkeitJobResultPage; 